import type { RotaPatternResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { ROTA_PATTERN_QUERY_KEY, ROTA_PATTERN_URL } from './queryConstants'

type UseRotaPatternDetailProps = {
  id?: string
}

type UseRotaPatternDetailReturn = {
  patternDetail?: RotaPatternResponse
  isLoadingDetail?: boolean
  refetchDetail?: () => void
}

export const useRotaPatternDetail = ({
  id
}: UseRotaPatternDetailProps): UseRotaPatternDetailReturn => {
  // DETAIL
  const detailParams = getQueryParams({
    fields: [
      '*',
      'resident.name',
      'resident.picture',
      'resident.status',
      'resident.id'
    ]
  })

  const {
    data: patternDetail,
    isLoading: isLoadingDetail,
    refetch: refetchDetail
  } = useQuery(
    [ROTA_PATTERN_QUERY_KEY, id] as string[],
    () =>
      getJSON({
        url: `${ROTA_PATTERN_URL}/${id}?${detailParams}`,
        isRota: true
      }),
    { enabled: !!id }
  )

  return {
    patternDetail,
    isLoadingDetail,
    refetchDetail
  }
}
